"use client";
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./LegalSolutions.css";
import BlueSectionDivider from "./BlueSectionDivider";
import { Link } from "react-router-dom";

const stats = [
  { value: "+90", label: "Specialists" },
  { value: "+20", label: "Industry sectors" },
  { value: "78", label: "Customer NPS Score" },
  { value: "99%", label: "Recommendation Rate" },
  { value: "+300", label: "Projects delivered" }
];

const cards = [
  {
    icon: <img src="/icons/case.webp" alt="Case Management" />,
    title: "CASE MANAGEMENT SOFTWARE",
    desc: "Simplify case tracking, document management, and collaboration with intuitive case management software."
  },
  {
    icon: <img src="/icons/contract.webp" alt="Contract Automation" />,
    title: "CONTRACT AUTOMATION PLATFORMS",
    desc: "Streamline the contract drafting and review process with automated contract management platforms, reducing errors and increasing efficiency."
  },
  {
    icon: <img src="/icons/compliance.webp" alt="Compliance Tools" />,
    title: "COMPLIANCE AND REGULATORY TOOLS",
    desc: "Ensure compliance with ever-changing regulations and mitigate risks with compliance management and regulatory tracking tools."
  }
];

export default function LegalSolutionsSection() {
  const [active, setActive] = useState("solutions");

  const sectionsToHighlight = [
    "solutions",
    "benefits",
    "tech stack",
    "faq",
    "contact us"
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = 80;
      const scrollY = window.scrollY + offset;

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i]);
        if (section && section.offsetTop <= scrollY) {
          setActive(sectionsToHighlight[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (id) => {
    setActive(id);
    const section = document.getElementById(id);
    section?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      {/* Sticky Navbar */}
      <div className="legal-navbar">
        <div className="container">
          <ul>
            {sectionsToHighlight.map((item) => (
              <li key={item}>
                <a
                  onClick={() => handleClick(item)}
                  className={active === item ? "active" : ""}
                >
                  {item.toUpperCase()}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Section Content */}
      <section className="legal-section" id="solutions">
        <div className="container">
          <div className="legal-stats-row" data-aos="fade-up">
            {stats.map((stat, i) => (
              <div className="legal-stat" key={i}>
                <div className="legal-stat-value">{stat.value}</div>
                <div className="legal-stat-label">{stat.label}</div>
              </div>
            ))}
            <BlueSectionDivider />
          </div>

          <div className="legal-title-group" data-aos="fade-up">
            <div className="legal-title">DIGITAL SOLUTIONS</div>
            <div className="legal-title-blue">
              FOR THE DIFFERENT LEGAL AREAS
            </div>
          </div>

          <div className="legal-cards-grid">
            {cards.map((card, i) => (
              <div
                className="legal-card"
                key={i}
                data-aos="fade-up"
                data-aos-delay={100 + i * 100}
              >
                <div className="legal-card-icon">{card.icon}</div>
                <div className="legal-card-title">{card.title}</div>
                <div className="legal-card-desc">{card.desc}</div>
              </div>
            ))}
          </div>

          <div className="legal-cta-row" data-aos="fade-up" data-aos-delay="600">
            <button className="legal-cta-btn">
              <Link to="/contact">GET STARTED WITH YOUR LEGAL DIGITAL PRODUCT</Link>
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
